// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"ComingSoon_text-gradient__3B4Sc","top":"ComingSoon_top__UA_Ka","body":"ComingSoon_body__1DdGG","title":"ComingSoon_title__2uYp5"};